export const imageAspectRatio = ['1:1', '3:4', '4:3', '16:9', ''] as const;
export type ImageAspectRatio = (typeof imageAspectRatio)[number];
